import type { FC } from 'react';
import Box from '@mui/material/Box';
import AccountsGrid from './AccountsGrid';
import { accountsFormValidator } from '../validation';
import { FormProvider, useForm } from 'react-hook-form';
import type { z } from 'zod';
import FilterSearch from './FilterSearch';
import { SelectApplications } from 'components/common';
import { useListParams } from 'hooks';

type FormData = z.infer<typeof accountsFormValidator.schema>;

const Accounts: FC = () => {
  const { apps, q } = useListParams();
  const formMethod = useForm<FormData>({
    resolver: accountsFormValidator.resolver,
    defaultValues: {
      q: q ?? undefined,
      apps: apps ? (apps as string[]) : undefined,
    },
  });

  return (
    <FormProvider {...formMethod}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <Box
          sx={{ display: 'flex', width: '100%', flexDirection: 'row', gap: 2 }}
        >
          <Box sx={{ flex: 2 }}>
            <FilterSearch placeholder={'Search account name or ID'} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <SelectApplications inputLabel={'Apps'} name="apps" multiples />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            width: '100%',
            height: '100%',
            position: 'relative',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
            }}
          >
            <AccountsGrid />
          </Box>
        </Box>
      </Box>
    </FormProvider>
  );
};

export default Accounts;
